/** One period the dialog will ask the ERP for. Bounds as ISO `YYYY-MM-DD`. */
export interface ErpSyncPeriodRow {
    periodStart: string;
    periodEnd: string;
}

/**
 * A period the dialog SHOWS rather than asks for.
 *
 * `name` and `range` arrive already formatted. A pure view has no business deciding how a date reads
 * in Swiss German versus English — the container holds the language and formats once.
 */
export interface ErpSyncShownPeriod {
    readonly name: string;
    readonly range: string;
}

/**
 * A period a journal already exists for.
 *
 * Listed and NOT editable: it is not pulled again. The journal is keyed on the company and the
 * period rather than on a closing, so re-pulling one would rewrite a journal another closing —
 * possibly a finished one — is read from.
 */
export interface ErpSyncHeldPeriod extends ErpSyncShownPeriod {
    readonly periodStart: string;
    readonly periodEnd: string;
}
